if($('#navigation-1 span[itemprop="name"]').text() === 'Klientské centrum'){
    $('body').addClass('customcilentCenter');
    $('.logout').after('<li><a href="/klient/">Souhrn</a></li>')
    $('.client-center-box li a').each(function(){
        var text = $(this).text().replace('Moje', '').trim();
        if (text.length > 0) {
            text = text.charAt(0).toUpperCase() + text.slice(1);
        }
        $(this).text(text);
    })
    if(document.location.pathname === '/klient/'){
        $('.client-center-box li a[href="/klient/"]').closest('li').addClass('active')
    }    

}

if($('.id--12').length){
    $('.content-inner>h2').text('Historie objednávek')
    $('.content-inner').append($('footer#footer .customPersonalAccount'))
    $('.myNetwork .networkRow .rowName .name').text($('.client-center-box ul li').first().text().trim())
    $('.topLineBarMoney:not([data-curency="'+getShoptetDataLayer('currency')+'"])').hide()
    $(window).on('load', function() {
        setTimeout(function(){
            if($('.mehub-bonus-profile-container').length){
                $('.personalLine .actualState .pointExpirates').text($('.mehub-bonus-profile-container .credit-expiration').text())
                let text = $('.mehub-bonus-profile-container .credit-value').text();
                let parts = text.split(' ');
                let number = parts.slice(0, -1).join(' ');
                let sklonovanyText = `<strong>${number}</strong> ${sklonovaniBodu(number)}`;
                $('.personalLine .actualState .points').html(sklonovanyText);
                $('.ActualStatePoints .yellowPoints').html(sklonovanyText);
                $('.ActualStatePoints .forShopping .points').html(sklonovanyText)
                $('.ActualStatePoints .forShopping .prize').html(sklonovanyText)
                $('.PointAccountDetail .left').append($('.mehub-bonus-profile-container'))
                let textExpirate = $('.mehub-bonus-profile-container .credit-expiration').text()
                let partsExpirate = textExpirate.split(' vyprší dne ');
                let partsExpiratetext = partsExpirate[0];
                let partsExpiratedate = partsExpirate[1];
                if($('.mehub-bonus-profile-container .credit-expiration').text() === ''){
                    $('.ActualStatePoints .expirePoints').html('<strong>0</strong> bodů')
                    $('.ActualStatePoints .expirePointsDate').text()
                    
                }
                else{
                    $('.ActualStatePoints .expirePoints').html('<strong>'+partsExpiratetext.split(' ')[0]+'</strong> '+sklonovaniBodu(partsExpiratetext))
                    $('.ActualStatePoints .expirePointsDate').text(' vyprší dne '+partsExpiratedate)
                }
                
            }
            else{
                console.error('Nenačetlo body')

            }
           
        }, 1250)
    })


    $(document).ready(function() {
        var urlFinal = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSaPvNoOnaxBJ6UusytZ7MPHjrh1DFB3ydBGvtZR0Qks3HGGojuc_Vm9DfMJ6TCRVOfaAJV7h8LACCb/pub?gid=929019958&single=true&output=csv';
        var customerEmail = getShoptetDataLayer('customer').email;
    
        function parseCSV(data) {
            var pattern = /(?:,|^)(\"(?:(?:\"\")*[^\"]*)*\"|[^,]*)/g;
            var rows = data.split('\n');
            return rows.map(function(row) {
                var matches = [];
                var match;
                while (match = pattern.exec(row)) {
                    matches.push(match[1].replace(/\"\"/g, '"').replace(/^\"|\"$/g, ''));
                }
                return matches;
            });
        }
    
        $.get(urlFinal, function(dataFinal) {
            var lines = parseCSV(dataFinal);
            var emailFoundFinal = false;
            for (var i = 0; i < lines.length; i++) {
                var items = lines[i];
                if (items[0].trim() === customerEmail.trim()) {
                    emailFoundFinal = true;
                    var item1 = parseInt(items[2]) || 0;
                    var item2 = parseInt(items[3]) || 0;
                    var item3 = parseInt(items[4]) || 0;
                    var item4 = parseInt(items[5]) || 0;
                    var item5 = parseInt(items[6]) || 0;
                    var sum = item1 + item2 + item3 + item4 + item5;
                    //údaje zákazníka
                    var customerData = getShoptetDataLayer('customer');
                    var fullName = customerData ? customerData.fullName : null;
                    var personalSettings = '<li class="name">' + (fullName ? fullName : '') + '</li>';
                    if (items[16].trim() !== '') {
                        personalSettings += '<li class="adress">' + items[16] + ', ' + items[19] + ' ' + items[18] + '</li>';
                    } else {
                        personalSettings += '<li class="adress">' + items[19] + ' ' + items[18] + '</li>';
                    }
                    personalSettings += '<li class="phone">' + items[17] + '</li>';
                    personalSettings += '<li class="email">' + customerEmail + '</li>';
                    $('.customPersonalAccount .personalSettings').append(personalSettings);
    
                    //splnění bodů
                    if(getShoptetDataLayer('currency') === 'EUR'){
                        $('.valueOrdersPrice h5 span').text(Number(items[9]/smennyKurz).ShoptetFormatAsCurrency());
                        if (parseFloat(items[9].trim()/smennyKurz) < 40) {
                            var percentil = (100 * parseFloat(items[9].trim()/smennyKurz)) / 40;
                            $('.pointsLineBarBottom .currentlySpent').attr('style', 'left:calc(' + percentil + '% - 50px);display:block;').text(Number(items[9]/smennyKurz).ShoptetFormatAsCurrency());
                            $('.pointsLineBarBottom').attr('style', 'margin-bottom:60px;');
                            $('.pointsLineBar .lineCustom').attr('style', 'width:' + percentil + '%;');
                        } else {
                            $('.pointsLineBarBottom').attr('style', 'margin-bottom:30px;');
                            $('.pointsLineBarBottom .currentlySpent').hide();
                            $('.pointsLineBar .lineCustom').attr('style', 'width:100%;');
                        }
                    }
                    if(getShoptetDataLayer('currency') === 'CZK'){
                        $('.valueOrdersPrice h5 span').text(Number(items[9]).ShoptetFormatAsCurrency());
                        if (parseFloat(items[9].trim()) < 999) {
                            var percentil = (100 * parseFloat(items[9].trim())) / 999;
                            $('.pointsLineBarBottom .currentlySpent').attr('style', 'left:calc(' + percentil + '% - 50px);display:block;').text(Number(items[9]).ShoptetFormatAsCurrency());
                            $('.pointsLineBarBottom').attr('style', 'margin-bottom:60px;');
                            $('.pointsLineBar .lineCustom').attr('style', 'width:' + percentil + '%;');
                        } else {
                            $('.pointsLineBarBottom').attr('style', 'margin-bottom:30px;');
                            $('.pointsLineBarBottom .currentlySpent').hide();
                            $('.pointsLineBar .lineCustom').attr('style', 'width:100%;');
                        }
                    }
                   
                    
    
                    //moje síť - počet lidí
                    $('.myNetwork .point.first .button').text(item1 + sklonujKontakty(item1));
                    $('.myNetwork .point.second .button').text(item2 + sklonujKontakty(item2));
                    $('.myNetwork .point.third .button').text(item3 + sklonujKontakty(item3));
                    $('.myNetwork .point.fourth .button').text(item4 + sklonujKontakty(item4));
                    $('.myNetwork .point.fifth .button').text(item5 + sklonujKontakty(item5));
    
                    //moje síť - celkem kontraktů
                    $('.myNetwork .networkRow .contactsFeed').text(sum + ' ' + sklonujKontakty(sum));
    
                    //body za aktuální měsíc
                    $('.overviews .actualMonthPoints p').first().find('span').html(items[8] + ' ' + sklonovaniBodu(items[8]));
                    $('.overviews .actualMonthPoints p').eq(1).find('span').html(items[1]);
                    if(getShoptetDataLayer('currency') === 'EUR'){
                        if (parseFloat(items[9]/smennyKurz) < 40) {
                            $('.overviews .actualMonthPoints .pointsToBeCredited span').html('0' + ' ' + sklonovaniBodu(0));
                        } else {
                            $('.overviews .actualMonthPoints .pointsToBeCredited span').html(items[8] + ' ' + sklonovaniBodu(items[8]));
                            $('.overviews .actualMonthPoints .remark').text('Splnil(a) jsi podmínky pro připsání bodů.');
                        }
                    }
                    if(getShoptetDataLayer('currency') === 'CZK'){
                        if (parseFloat(items[9]) < 999) {
                            $('.overviews .actualMonthPoints .pointsToBeCredited span').html('0' + ' ' + sklonovaniBodu(0));
                        } else {
                            $('.overviews .actualMonthPoints .pointsToBeCredited span').html(items[8] + ' ' + sklonovaniBodu(items[8]));
                            $('.overviews .actualMonthPoints .remark').text('Splnil(a) jsi podmínky pro připsání bodů.');
                        }
                    }
                   
    
                    //body za minulý měsíc
                    $('.overviews .lastMonthPoints p').first().find('span').html(items[12] + ' ' + sklonovaniBodu(items[12]));
                    $('.overviews .lastMonthPoints p').eq(1).find('span').html(items[14]);
                    
                    if (parseFloat(items[13]) < 999) {
                        $('.overviews .lastMonthPoints .pointsToBeCredited span').html(items[12] + ' ' + sklonovaniBodu(items[12]));
                    } else {
                        $('.overviews .lastMonthPoints .pointsToBeCredited span').html(items[12] + ' ' + sklonovaniBodu(items[12]));
                        $('.overviews .lastMonthPoints .remark').text('Splnil(a) jsi podmínky pro připsání bodů.');
                    }
    
                    //aktuální stav bodového konta pro nákupy
    
                    //aktuální stav bodového konta pro výplatu
                    if (parseFloat(items[8]) > 5000) {
                        $('.ActualStatePoints .forPayouts .points').html(items[8] + ' ' + sklonovaniBodu(items[8]));

                        if(getShoptetDataLayer('currency') === 'EUR'){
                            $('.ActualStatePoints .forPayouts .prize').html(Number((parseFloat(items[8])/25) / 2).ShoptetFormatAsCurrency());
                        }
                        if(getShoptetDataLayer('currency') === 'CZK'){
                            $('.ActualStatePoints .forPayouts .prize').html(Number(parseFloat(items[8]) / 2).ShoptetFormatAsCurrency());
                        }
                    


                        $('.ActualStatePoints .btnPoints').addClass('notDisabled');
                        $('.PaymentOfPointsForm .totalPointsForPayment span').html('<strong>' + items[8] + '</strong> ' + sklonovaniBodu(items[8]));
                        $('.PaymentOfPointsForm .inputrow input.points').attr('max', items[8]);
                    }
                    break;
                }
            }
            if (!emailFoundFinal) {
                $('.valueOrdersPrice h5 span').text(Number(0).ShoptetFormatAsCurrency());
    
                $('.pointsLineBarBottom').attr('style', 'margin-bottom:30px;');
                $('.pointsLineBarBottom .currentlySpent').hide();
                $('.pointsLineBar .lineCustom').attr('style', 'width:0%;');
    
                //moje síť - počet lidí
                $('.myNetwork .point.first .button').text('0 kontaktů');
                $('.myNetwork .point.second .button').text('0 kontaktů');
                $('.myNetwork .point.third .button').text('0 kontaktů');
                $('.myNetwork .point.fourth .button').text('0 kontaktů');
                $('.myNetwork .point.fifth .button').text('0 kontaktů');
    
                //moje síť - celkem kontraktů
                $('.myNetwork .networkRow .contactsFeed').text('0 kontaktů');
    
                //body za aktuální měsíc
                $('.overviews .actualMonthPoints p').first().find('span').html('0 bodů');
                $('.overviews .actualMonthPoints p').eq(1).find('span').html(items[1]);
    
                $('.overviews .actualMonthPoints .pointsToBeCredited span').html('0 bodů');
                $('.overviews .actualMonthPoints .remark').text('Nesplnil(a) jsi podmínky pro připsání bodů.');
    
                //body za minulý měsíc
                $('.overviews .lastMonthPoints p').first().find('span').html('0 bodů');
                $('.overviews .lastMonthPoints p').eq(1).find('span').html('0 bodů');
                $('.overviews .lastMonthPoints .pointsToBeCredited span').html('0 bodů');
                $('.overviews .lastMonthPoints .remark').text('Nesplnil(a) jsi podmínky pro připsání bodů.');
    
                //aktuální stav bodového konta pro nákupy
                $('.ActualStatePoints .forShopping .points').html('0 bodů');
                $('.ActualStatePoints .forShopping .prize').html(Number(0).ShoptetFormatAsCurrency());
    
                //aktuální stav bodového konta pro výplatu
                $('.ActualStatePoints .forPayouts .points').html('0 bodů');
                $('.ActualStatePoints .forPayouts .prize').html(Number(0).ShoptetFormatAsCurrency());
                $('.ActualStatePoints .btnPoints').addClass('notDisabled');
                $('.PaymentOfPointsForm .totalPointsForPayment span').html('<strong>0</strong> bodů');
                $('.PaymentOfPointsForm .inputrow input.points').attr('max', 0);
            }
        });
    });
    

    $(document).on('click', '.btnPoints', function(){
        $.colorbox({
            html: '<div class="PaymentOfPointsForm">'+$('footer#footer .PaymentOfPointsForm').html()+'</div>',
            width: 800,
            maxWidth: "95%",
            height: 650,
            maxHeight: "95%",
            className: "PaymentOfPointsForm",
            onComplete: function() {
                
            }
        })
    })

    $(document).on('click', '.inputrow .rotate', function(){
        $(this).closest('.inputrow').hide()
        $(this).closest('.inputrow').find('input').val()
        $('.inputrow.'+$(this).attr('data-value')).show()
    })

    $(document).on('submit', '.paymentForm', function(e){
        $(this).addClass('loading-form')
        e.preventDefault(); 
        var formName = getShoptetDataLayer('customer').fullName
        var formEmail = getShoptetDataLayer('customer').email
        var formPoints = $(this).find('.inputrow .points').val()
        var formMoney = $(this).find('.inputrow .money').val()
        var formBankAcount = $(this).find('.inputrow .banknumber').val()
        var formBankcode = $(this).find('.inputrow .bankcode').val()
        var formBankIban = $(this).find('.inputrow .iban').val()
        var formBankSwift = $(this).find('.inputrow .swift').val()
        var currentDateTime = getCurrentDateTime();
        var formdata = new FormData();
        formdata.append("name", formName);
        formdata.append("email", formEmail);
        formdata.append("points", formPoints);
        formdata.append("money", formMoney);
        formdata.append("bankAcount", formBankAcount);
        formdata.append("bankCode", formBankcode);
        formdata.append("bankIban", formBankIban);
        formdata.append("bankSwift", formBankSwift);
        formdata.append("dateTime", currentDateTime);
        var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
        };
        fetch("https://tools.shopcode.cz/e-mail_sender/cista-radost/www/", requestOptions)
        .then(response => response.json())
        .then(function(result){
        showMessage('Formulář byl úspěšně odeslán, budeme vás kontaktovat.', 'success', '', false, true);
            if(result.status === 'ok'){
                $('#poptavkovyForm').removeClass('loading-form')
            }
        })
        .catch(function(){
            showMessage('Při odeslání nastala chyba, zkuste to prosím znovu.', 'error', '', false, true);
            $('#poptavkovyForm').removeClass('loading-form')
        })
    });

    function getCurrentDateTime() {
        var now = new Date();
        var day = ('0' + now.getDate()).slice(-2);
        var month = ('0' + (now.getMonth() + 1)).slice(-2);
        var year = now.getFullYear();
        var hours = ('0' + now.getHours()).slice(-2);
        var minutes = ('0' + now.getMinutes()).slice(-2);
        var seconds = ('0' + now.getSeconds()).slice(-2);

        return day + "." + month + "." + year + " v " + hours + ":" + minutes + ":" + seconds;
    }

    $(document).on('input', '.inputClass.points', function() {
        var value = $(this).val();
        $('.inputClass.money').val(formatNumber(value/2));
    });

    function formatNumber(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    function sklonujKontakty(count) {
        if (count === 0) {
            return " kontaktů";
        } else if (count === 1) {
            return " kontakt";
        } else if (count >= 2 && count <= 4) {
            return " kontakty";
        } else {
            return " kontaktů";
        }
    }
   
    function sklonovaniBodu(number) {
        number = parseInt(number.replace(/\s/g, ''));
        if (number === 1) {
            return "bod";
        } else if (number >= 2 && number <= 4) {
            return "body";
        } else {
            return "bodů";
        }
    }



}

if($('.id--13').length){
    $('#company-info').addClass('visible');
    $('input#company-shopping').prop('checked')
    $('input#company-shopping').closest('.company-shopping').addClass('unveiled')
    $('#company-info label[for="billCompany"]').html('<span class="required-asterisk">E-mail partnera</span>')
    if($('input[name="billCompany"]').val() === ''){
        $('input[name="billCompany"]').val(localStorage.getItem('partnerEmail'))
        setTimeout(function(){
            $('#register-form .submit-wrapper input[type="submit"]').trigger('click')
        }, 500)
    }
    $('.co-registration fieldset label[for="email"]').closest('.form-group').after($('#company-info'))
    $('.submit-wrapper').before($('label[for="currentPassword"]').closest('.form-group'))
    $('label[for="password"]').closest('.form-group').before('<h4 class="newPasword">Nastavení nového hesla</h4>')
    if($('.co-registration>p').first().text() === 'Záznamy nebyly nalezeny...'){
        $('.co-registration>p').first().text('Doručovací adresa je stejná jako fakturační.')
    }
    var urlFinal = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSaPvNoOnaxBJ6UusytZ7MPHjrh1DFB3ydBGvtZR0Qks3HGGojuc_Vm9DfMJ6TCRVOfaAJV7h8LACCb/pub?gid=929019958&single=true&output=csv'
    var customerEmail = getShoptetDataLayer('customer').email;
    
    
    $.get(urlFinal, function(dataFinal) {
        var lines = dataFinal.split('\n');
        var emailFoundFinal = false;
        for (var i = 0; i < lines.length; i++) {
            var items = lines[i].split(',');
            if (items[0].trim() === customerEmail.trim()) {
             //   console.log(items)
                emailFoundFinal = true
                if($('#billCompany').val() === ''){
                    $('#billCompany').val(items[20])
                }
            }
        }
    })
}

if($('.id--8').length){
    $('#register-form').before(registracniText)
    $('#register-form .co-registration>fieldset').after('<div class="form-group flexik"><label for="partnerEmail"><span class="required-asterisk">E-mail partnera</span></label><input type="email" id="partnerEmail" name="partner-email" class="form-control" required><div class="text-left"><span class="partnerEmailButton">Ověřit partnerský e-mail</span></div></div>')
    $(document).on('click', '#register-form input[type="submit"]', function(event) {
        var partnerEmail = $('#partnerEmail').val().trim();
        if (partnerEmail === '') {
            partnerEmail = 'admin@cista-radost.cz';
        }
        localStorage.setItem('partnerEmail', partnerEmail);
    })
    $(document).on('click', '.partnerEmailButton', function(){
        var closestDiv = $(this).closest('.form-group')
        var partnerEmail = $(this).closest('.form-group').find('#partnerEmail').val()
        var urlFinal = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSaPvNoOnaxBJ6UusytZ7MPHjrh1DFB3ydBGvtZR0Qks3HGGojuc_Vm9DfMJ6TCRVOfaAJV7h8LACCb/pub?gid=929019958&single=true&output=csv'
        $.get(urlFinal, function(dataFinal) {
            var lines = dataFinal.split('\n');
            var partnerFound = false;
            for (var i = 0; i < lines.length; i++) {
                var items = lines[i].split(',');
                if (items[0].trim() === partnerEmail) {
                    partnerFound = true;
                    break; // Ukončí smyčku, pokud e-mail nalezen
                }
            }
            closestDiv.find('p.green, p.red').remove();

            if (partnerFound) {
                $('.submit-wrapper').addClass('allow')
                closestDiv.append('<p class="green">'+validniEmailPartnera+'</p>');
            } else {
                closestDiv.append('<p class="red">'+nevalidniEmailPartnera+'</p>');
            }
        })

        
    })

    
}
